
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";

// Class parent of all icons components for typing & tree structure purpose
export class CjsIcon extends WebComponent { }